/**
 * Current user location instance
 *
 * @example
 * var currentUserLocationModel = require('shared/model/current_user_location');
 * currentUserLocationModel.fetch();
 */

import UserLocation from 'model/user_location'

export default new UserLocation()
